import {
  DeleteRequest,
  GetRequest,
  PostRequest,
  PutRequest,
} from "../../plugins/https";
import {
  setNotice,
  getNotice,
  deleteNotice,
  updateNotice,
  getOneNotice,
  deleteImage,
  addImage,
} from "./action";
import {
  SET_NOTICE,
  GET_NOTICE,
  DELETE_NOTICE,
  UPDATE_NOTICE,
  GET_ONE_NOTICE,
  DELETE_IMAGE,
  ADD_PHOTOS,
} from "./actionType";

export const getNoticeData = async (dispatch) => {
  try {
    const res = await GetRequest("/notice");
    dispatch(getNotice(res.data));
  } catch (error) {
    console.error("Error getting Notice: ", error);
  }
};

export const addNotice = (Notice) => async (dispatch) => {
  try {
    const response = await PostRequest("/notice", Notice);
    dispatch(setNotice(response.data));
    dispatch(getNoticeData);
  } catch (error) {
    console.error(error);
  }
};

export const deleteNoticeData = (id) => async (dispatch) => {
  try {
    const res = await DeleteRequest(`/notice/${id}`);
    dispatch(deleteNotice(id));
    dispatch(getNoticeData);
  } catch (error) {
    console.error("Error in deleting notice: ", error);
  }
};

export const updateNoticeData = (id, updateNoticeData) => async (dispatch) => {
  try {
    const res = await PutRequest(`/notice/${id}`, updateNoticeData);
    dispatch(updateNotice(res.data));
    dispatch(getNoticeData);
  } catch (error) {
    console.error("Error in updating notice: ", error);
  }
};

export const getOneNoticeData = (id) => async (dispatch) => {
  try {
    const res = await GetRequest(`/notice/${id}`);
    dispatch(getOneNotice(res.data));
  } catch (error) {
    console.error("Error getting notice: ", error);
  }
};

export const deleteOneImage = (id, photo) => async (dispatch) => {
  try {
    const res = await DeleteRequest(`/notice/${id}/${photo}`);
    dispatch(deleteImage(id, photo));
  } catch (error) {
    console.error("Error in deleting notice image: ", error);
  }
};
export const addPhotos = (Gallery, id) => async (dispatch) => {
  try {
    const res = await PutRequest(`/notice/${id}/photos`, Gallery);
    dispatch(addImage(res.data.photos)); // Ensure `res.data.photos` is the correct structure
  } catch (error) {
    console.error("Error in adding notice photo: ", error);
  }
};

const initialState = {
  notice: "",
  noticeData: [],
  OneNoticeData: [],
};

export const noticeReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_NOTICE:
      return {
        ...state,
        notice: action.payload,
      };
    case GET_NOTICE:
      return {
        ...state,
        noticeData: action.payload,
      };
    case DELETE_NOTICE:
      return {
        ...state,
        noticeData: state.noticeData.filter(
          (item) => item.id !== action.payload
        ),
      };
    case UPDATE_NOTICE:
      return {
        ...state,
        noticeData: state.noticeData.map((item) =>
          item.id === action.payload.id ? { ...item, ...action.payload } : item
        ), // Update the specific item
      };
    case GET_ONE_NOTICE:
      return {
        ...state,
        OneNoticeData: action.payload,
      };
    case DELETE_IMAGE:
      return {
        ...state,
        OneNoticeData: {
          ...state.OneNoticeData,
          photos: state.OneNoticeData.photos.filter(
            (photo) => photo._id !== action.payload.photo._id // Remove the deleted photo
          ),
        },
      };
    case ADD_PHOTOS:
      return {
        ...state,
        OneNoticeData: {
          ...state.OneNoticeData,
          photos: [...state.OneNoticeData.photos, ...action.payload], // Append new photos
        },
      };
    default:
      return state;
  }
};
